import React, { useState, useCallback } from 'react';
import Table from '../../../../../components/_table/Table';
import Modal from '../../../../../components/Modal';
import { columns } from './columns';
import './SearchProductCategoryModal.scss';

const SearchProductCategoryModal = (props) => {
  const { data, isOpen, selectedIdList, onClickItem, onSubmit, closeModal } = props;
  const { productCategoryTreeList, productCategoryAllList } = data;
  const [mainCategory, setMainCategory] = useState(null);

  const onCheck = useCallback(
    (idList, id) => {
      if (!id) {
        // 전체 선택 클릭 시 아무런 동작을 하지 않도록 함
        return;
      }

      const targetCategory = productCategoryAllList.find((item) => item.id === id);
      if (targetCategory && !targetCategory.parentId) {
        // 1차 카테고리 확인
        onClickItem([id]);
        setMainCategory(targetCategory);
      } else {
        // 2차 카테고리 확인
        if (mainCategory && mainCategory.id === targetCategory.parentId) {
          onClickItem(idList);
        } else {
          onClickItem([targetCategory.parentId, id]);
          setMainCategory(productCategoryAllList.find((item) => item.id === targetCategory.parentId));
        }
      }
    },
    [mainCategory, productCategoryAllList, onClickItem],
  );

  return (
    <Modal
      title="상품 카테고리 검색"
      isOpen={isOpen}
      width={720}
      height={650}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-item-modal">
        <div className="help-text">*APP/WEB 에 노출중인 카테고리 리스트</div>

        <Table
          columns={(utils) =>
            columns({
              ...utils,
            })
          }
          rowKey={(record) => record.productCategoryId}
          onCheck={onCheck}
          selectedList={selectedIdList}
          list={productCategoryTreeList}
          size="small"
          scroll={{ x: true }}
          bordered={true}
        />
      </div>
    </Modal>
  );
};

export default SearchProductCategoryModal;
